export default __webpack_public_path__ + "static/media/certificate.ccd65e32.jpg";